import axios from 'axios'
import store from '../store'
import Cookies from 'js-cookie'

const instance = axios.create({
  //本地 /prod-api 生产 /kjpt/prod-api
  baseURL: "/prod-api",
  // http://192.168.1.7:8081
  timeout: 100000,
  headers: {
    Accept:
      "text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,*/*;q=0.8",
    "Content-Type": "application/json",
  },
})

instance.interceptors.request.use((config) => {
  console.log(store)
  if (config.url == "/user/login") {
    return config;
  } else {
    console.log("store的值", store.state.token)
    config.headers.token = store.state.token
    // 从 cookie 读取 token，加到 Authorization header
    const token = Cookies.get('Admin-Token')
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    return config
  }
})
instance.interceptors.response.use(res => {
  // console.log(res)
  return res.data
})
export default instance;